import React from 'react';
import { mockData } from '../mock';
import { Quote } from 'lucide-react';
import transformationImage from '../assets/david-m.jpg';

const Transformacion = () => {
  return (
    <section id="transformacion" className="section section-darker">
      <div className="container">

        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <span style={{
            color: 'var(--accent-primary)',
            fontWeight: 600,
            fontSize: '1.32rem',
            letterSpacing: '0.15em',
            textTransform: 'uppercase'
          }}>
            Donde el método se convierte en resultados
          </span>
        </div>

        {/* Testimonials Grid */}
        <div className="testimonials-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '2rem'
        }}>
          {mockData.testimonials.map((testimonial) => {
            const isFeatured = testimonial.id === 1; // Destacamos el primer testimonio
            return (
            <div key={testimonial.id} className={isFeatured ? "featured-testimonial" : ""} style={{
              background: 'var(--bg-card)',
              border: '1px solid var(--border-subtle)',
              borderRadius: '8px',
              padding: isFeatured ? '0' : '2.5rem',
              display: 'flex',
              flexDirection: isFeatured ? 'row' : 'column',
              gap: isFeatured ? '0' : '1.5rem',
              overflow: 'hidden',
              transition: 'transform 0.3s ease, border-color 0.3s ease',
              cursor: 'default',
              gridColumn: isFeatured ? '1 / -1' : 'auto'
            }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.borderColor = 'var(--accent-primary)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'var(--border-subtle)';
              }}>
              
              {/* Contenido (Texto) */}
              <div style={{
                padding: '2.5rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '1.5rem',
                flex: isFeatured ? '1 1 50%' : 'auto'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: 'var(--accent-primary)',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Quote size={22} color="#ffffff" />
                </div>

                <p className="body-medium" style={{
                  color: 'var(--text-primary)',
                  lineHeight: 1.7,
                  flex: 1
                }}>
                  {testimonial.quote}
                </p>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  paddingTop: '1rem',
                  borderTop: '1px solid var(--border-subtle)'
                }}>

                  <div>
                    <div style={{
                      fontWeight: 600,
                      color: 'var(--text-primary)',
                      marginBottom: '0.25rem'
                    }}>
                      {testimonial.name}
                    </div>
                    <div style={{
                      fontSize: '1.05rem',
                      color: 'var(--text-secondary)'
                    }}>
                      {testimonial.role}
                    </div>
                  </div>
                </div>
              </div>

              {/* Imagen Destacada para el primer testimonio */}
              {isFeatured && (
                <div className="featured-image-container" style={{
                  flex: '1 1 50%',
                  minHeight: '300px',
                  position: 'relative'
                }}>
                  <img 
                    src={transformationImage} 
                    alt="Atleta en acción" 
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'top',
                      position: 'absolute',
                      top: 0,
                      left: 0
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(to right, var(--bg-card) 0%, transparent 15%)',
                    pointerEvents: 'none'
                  }}></div>
                </div>
              )}
            </div>
          )})}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .testimonials-grid {
            grid-template-columns: 1fr !important;
          }
          .featured-testimonial {
            flex-direction: column !important;
          }
          .featured-image-container {
            min-height: 250px !important;
          }
          .featured-image-container div {
            background: linear-gradient(to bottom, var(--bg-card) 0%, transparent 20%) !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Transformacion;
